import React from "react";
import NavbarComponent from "./NavbarComponent";
import "./layoutUser.css";



const LayoutUser = ({ children, logout,setSidebarOpen,sidebarOpen,showSidebar }) => {
    return (
        <>
            <NavbarComponent showSidebar={showSidebar} sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} logout={logout} />
            <div  className="main-container-user">
                {children}
            </div>
        </>
    );
};

export default LayoutUser;
